














































































// import { ValidationProvider } from 'vee-validate';

export default {
  name: 'Contact',
  components: {
    // ValidationProvider
  },
  data() {
    return {
      valid: true,
      // name: null,
      subject: null,
      message: null,
      rules: {
        required: (value: string) => !!value || 'Required.'
      }
    };
  },
  methods: {
    async openMail() {
      const valid = await this.validate();
      console.log(valid);
      if (!(this as any).valid) {
        return;
      }
      const mail = 'h.s.hyunsik@gmail.com';
      window.open(
        `mailto:${mail}?subject=${(this as any).subject}&body=${
          (this as any).message
        }`
      );
    },
    validate(): boolean {
      return (this as any).$refs.form.validate();
    },
    reset() {
      (this as any).$refs.form.reset();
    },
    resetValidation() {
      (this as any).$refs.form.resetValidation();
    }
  }
};
